<template>
  <div
    v-if="price"
    class="product-price"
    :class="[
      size ? 'product-price--' + size : '',
      type ? 'product-price--' + type : '',
      { 'product-price--vertical': vertical }
    ]"
  >
    <span class="product-price__current"
          :class="{ 'product-price__current--sale': isSale }"
    >{{ price | CurrencyFormatter }} {{ currency }}</span
    >
    <del v-if="isSale" class="product-price__old">{{ oldPrice | CurrencyFormatter }} {{ currency }}</del>
  </div>
</template>

<script>
import CurrencyFormatter from '../../filters/CurrencyFormatter'

export default {
  name: 'ProductPrice',
  props: {
    price: {
      type: Number,
      default: null
    },
    oldPrice: {
      type: Number,
      default: null
    },
    currency: {
      type: String,
      default: 'грн'
    },
    vertical: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    isSale: function () {
      return this.oldPrice && this.oldPrice > this.price
    }
  },
  filters: {
    CurrencyFormatter
  }
}
</script>

<style lang="sass" scoped>
.cart__wrapper
  .product-price
    flex-direction: column

.product-price
  display: flex
  flex-flow: row wrap
  align-items: baseline

.product-price--reverse
  flex-direction: row-reverse
  flex-wrap: wrap-reverse

  .product-price__current--sale
    margin-right: 0
    margin-left: 16px

.product-price--vertical
  display: flex
  flex-flow: column-reverse wrap

.product-price--adaptive-main-page
  +mmax(768)
    display: flex
    flex-flow: column-reverse wrap

.product-price--simple-card
  display: flex
  flex-flow: column-reverse wrap

.product-price--large
  .product-price__current
    font-size: 32px
    line-height: 40px
    font-weight: 500
  .product-price__old
    font-size: 18px

.product-price--medium
  .product-price__current
    font-size: 24px
    line-height: 28px
  .product-price__old
    font-size: 16px
    margin-bottom: 5px

.product-price--small
  .product-price__current
    font-size: 20px
    line-height: 24px

.product-price__current
  font-weight: 500
  font-size: 20px
  line-height: 24px
  color: $text-color
  white-space: nowrap

  &--sale
    color: $main-color
    margin-right: 16px

.product-price--vertical .product-price__current--sale
  margin-right: 0

.product-price--adaptive-main-page
  .product-price__current--sale
    +mmax(768)
      margin-right: 0

  .product-price__current
    +mmax(768)
      line-height: 1
      font-size: 16px

  .product-price__old
    +mmax(768)
      line-height: 1
      font-size: 12px

.product-price--simple-card
  .product-price__current--sale
    margin-right: 0

  .product-price__current
    line-height: 1
    font-size: 14px

  .product-price__old
    line-height: 1
    font-size: 12px
    margin-bottom: 5px

.product-card-comparison__price:not(.product-price--simple-card) .product-price__current--sale
  margin-right: 0

  +mmin(800)
    margin-right: 13px

.product-price__old
  font-weight: 400 //Rubik 300
  font-size: 14px
  line-height: 17px
  color: $placeholder-color
  text-decoration-width: 1px
  text-decoration-color: $main-color
  white-space: nowrap

.product-card__price:not(.product-price--simple-card) .product-price__old
  margin-bottom: 5px

  +mmin($tablet)
    margin-bottom: 0

.sets-with-product .product-price__current
  font-size: 18px

  +mmin($tablet)
    font-size: 20px
</style>
